export const addOneHour = (date: Date) => {
  const newDate = new Date(date.valueOf());
  newDate.setHours(newDate.getHours() + 1);
  return newDate;
};
